module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAMElEQVR4AWNYsGDxTHLx4aMnenDjUfz+49cGeuJ3m7ZNIh2P4lE8ikfxKAaVofTGADfTgd1iKitiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/selfcare_steptracker+left+maincontainer.png
// module id = 355
// module chunks = 0